import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default class CardSlides {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if (document.querySelectorAll('.card-slides__slideItem').length > 1) {
			this.swiper = new Swiper('.card-slides__slideActive', {
				loop: true,
				modules: [Navigation, Pagination, Autoplay],
				slidesPerView: 1,
				spaceBetween: 0,
				autoplay: {
					delay: 8000,
					disableOnInteraction: false
				},
				navigation: {
					nextEl: '.card-slides__slideArrowNext',
					prevEl: '.card-slides__slideArrowPrev'
				},
				pagination: {
					el: '.card-slides__pagination',
					clickable: true,
					type: 'bullets'
				}
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
